export default function LogoMain({ isLarge, isLight }) {
  return isLight ? (
    <img src="/logo/logo.svg" alt="OYN" className={isLarge ? 'w-30' : 'w-20'} />
  ) : (
    <img src="/logo/light-logo.png" alt="OYN" className={isLarge ? 'w-30' : 'w-20'} />
  );
}
